import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  ...zhLocale,
  notification:{
    title:'提示',
    adminmanagemessage:'此操作将永久删除该管理员，是否继续？',
    adminmanagemessage1:'不能查询自己的信息，请在个人中心中查看',
    adminmanagemessage2:'未查询到相关信息',
    adminlogmessage:'此操作将永久删除该日志信息，是否继续？',
    permissionmanagemessage:'此操作将永久删除该角色，是否继续？',
    permissionmanagemessage2:'角色信息还未填写完整！',
    carbrandmessage:'此操作将永久删除该品牌及该品牌对应的其他信息，是否继续？',
    cardatadeletemessage:'此操作将永久删除该车辆信息，是否继续？',
    adminfilemessage:'此操作将永久删除该OTA文件，是否继续？',
    appfilemessage:'此操作将永久删除该APP文件，是否继续？',
    userfilemessage:'此操作将永久删除该OTA文件，是否继续？',
    sensorbaseinfomessage:'此操作将永久删除该传感器信息及传感器数据，是否继续？',
    sensordatamessage:'此操作将永久删除该传感器数据，是否继续？',
    applogmessage:'此操作将永久删除该日志信息，是否继续？',
    syslogmessage:'此操作将永久删除该日志信息，是否继续？',
    homemessage:'登出？',
    confirm:'确定',
    cancel:'取消',
    cancelinfo:'已取消删除',
    cancelinfohome:'已取消登出',
    resetpwdmessage1:'旧密码不能为空',
    resetpwdmessage2:'新密码不能为空',
    resetpwdmessage3:'长度在 3 到 20 个字符',
    resetpwdmessage4:'确认密码不能为空',
    usermanagemessage1:'已取消修改密码',
    cardatamessage:'请选择要查询的类型',
  },
  login: {
    login_title: '保富胎压监控系统',
    login_welcome: '欢迎登录',
    username: '请输入用户名',
    password: '请输入密码',
    login: '登录',
    
    
  },
  home:{
    home_title:'保富胎压监控系统',
    MyInfo:'个人中心',
    logout:'退出登录',
    homepage:'首页',
    state1:'早上好!',
    state2:'中午好!',
    state3:'下午好!',
    state4:'晚上好!',
    home_welcome:'欢迎回来！',
    users:'用户总数',
    admins:'管理员总数',
    cars:'车辆总数',
    basicline:{
      title:'用户使用量',
      series:'总人数',
    },
  },
  file:{
    filename:'文件管理',
    userfile:{
      title:'用户文件管理',
      searchhint:'输入用户手机号获取用户文件，按回车键或搜索键进行搜索',
      searchbtn:'搜索',
      phone:'用户手机号',
      filename:'文件名',
      version:'传感器软件版本',
      createtime:'文件上传时间',
      operate:'操作',
      download:'下载',
      delete:'删除',
    },
    adminfile:{
      title:'OTA文件管理',
      sesrchhint:'输入管理员账号搜索文件',
      searchbtn:'搜索',
      insertbtn:'上传文件',
      uploadtitle:'上传OTA文件',
      uploadbrandcn:'汽车品牌(中文)',
      uploadbranden:'汽车品牌(英文)',
      uploadcarmodel:'车型',
      uploadcaryear:'年份',
      uploadcarconfig:'配置',
      uploadphone:'用户手机号',
      uploadversion:'软件版本号',
      uploadupload:'上传',
      uploadcancel:'取消',
      adminname:'管理员',
      otaname:'文件名',
      version:'软件版本号',
      phone:'手机号',
      createtime:'上传时间',
      operate:'操作',
      operatedownload:'下载',
      operatedelete:'删除',
    },
    appfile:{
      title:'APP文件管理',
      searchhint:'输入app名称搜索文件',
      searchbtn:'搜索',
      insertbtn:'上传',
      uploadtitle:'上传APP文件',
      uploadphone:'手机号',
      uploadapplicationID: '软件ID',
      uploadversionname:'软件名',
      uploadversioncode:'版本号',
      old_versioncode:'原始软件版本号',
      update_detail:'更新信息',
      incremental_update:'增量更新',
      uploadupload:'上传',
      uploadcancel:'取消',
      appname:'软件名',
      version:'版本号',
      phone:'手机号',
      createtime:'上传时间',
      operate:'操作',
      operatedownload:'下载',
      operatedelete:'删除',
    
    },
  },
  adminmanage:{
    adminmanagename:'管理员数据管理',
    searchadminhint:'通过用户名搜索管理员',
    insertadmin:'新增管理员',
    insertadmin_title:'新增管理员',
    insertadmin_account:'管理员账号',
    insertadmin_pwd:'密码',
    insertbtn:'新增',
    insertcancel:'取消',
    search:'搜索',
    name:'用户名:',
    createtime:'创建时间:',
    unable:'冻结',
    enable:'正常',
    userrole:'用户角色:',
    rolelist:'角色列表',
    select:'请选择',
  },
  admin:{
    adminmanage_title:'管理者信息',
    permissionmanage_title:'角色与权限管理',
  },
  permissionmanage:{
    role:'角色',
    newrole:'新增角色',
    hint1:'请输入角色英文名',
    hint2:'请输入角色中文名',
    span1:'可访问资源',
    cancelmodify:'取消修改',
    confirmmodify:'确认修改',
  },
  usersmanage:{
    usersmanagename:'用户数据管理',
    searchviaphone:'输入用户手机号/邮箱,按回车键搜索',
    btnsearch:'搜索',
    btninsertuser:'新增用户',
    insertuser_title:'新增用户',
    username:'姓名',
    phone:'手机号/邮箱',
    avatar:'头像',
    registtime:'注册时间',
    equipment:'最后登录设备',
    equipment1:'Web端',
    equipment2:'Android端',
    equipment3:'小程序端',
    equipment4:'iOS端',
    owncar:'拥有车辆\n(单击查看详情)',
    operate1:'操作',
    operate1_modifypassword:'修改密码',
    operate1_modifyinfo:'修改信息',
    operate1_delete:'删除',
    operate1_deletewarn:'此操作将永久删除该用户, 是否继续?',
    operate1_deletewarnyes:'确定',
    operate1_deletewarnno:'取消',
    deletewarnnomessage:'已取消删除',
    carsinfo:'的车辆信息',
    carsinfo_modify_title:'修改用户车辆',
    carsinfo_id:'用户车辆关联ID',
    carsinfo_brand:'品牌',
    carsinfo_year:'年份',
    carsinfo_configuration:'配置',
    carsinfo_createtime:'创建时间',
    carsinfo_vin:'Vin码',
    carsinfo_licenseplate:'车牌',
    carsinfo_operate:'操作',
    carsinfo_operate_modify:'修改',
    carsinfo_operate_modify_cancel:'取消',
    carsinfo_operate_delete:'删除',
    carsinfo_operate_deletewarn:'此操作将永久删除该用户车辆信息, 是否继续?',
    carsinfo_operate_deletewarnyes:'确定',
    carsinfo_operate_deletewarnno:'取消',
    modifypwd_title:'修改密码',
    modifypwd_phone:'用户手机号',
    modifypwd_newpwd:'新密码',
    modifypwd_newpwdagain:'确认新密码',
    modifypwd_cancel:'取消',
    modifypwd_modifypwd:'修改密码',
    modifypwd_difpwd:'两次密码不相同，请重新输入！',
    modifyinfo_title:'修改用户信息',
    modifyinfo_name:'姓名',
    modifyinfo_phone:'手机号',
    modifyinfo_pwd:"密码",
    modifyinfo_enabled:'非冻结',
    modifyinfo_unabled:'冻结',
    modifyinfo_modify:'修改',
    modifyinfo_cancel:'取消',
  },
  carsmanage:{
    carsmanagename:'车型库管理',
    title1:'车型管理',
    title2:'车辆品牌管理',
    cardata:{
      hint1:'请选择',
      select:{
        brandcn:'品牌(中文)查询',
        branden:'品牌(英文)查询',
        model:'车型查询',
        year:'年份查询',
        configuration:'配置查询',
      },
      hint2:'请输入内容',
      insert:{
        title:'新增车型',
        btn:'新增',
      },
      brandcn:'车辆品牌(中文)',
      branden:'车辆品牌(英文)',
      model:'车辆车型',
      year:'车辆年份',
      configuration:'车辆配置',
      createtime:'上传时间',
      operate:'操作',
      modify:{
        btn:'修改',
        title:'修改车辆',
        id:'车辆ID',
        cancel:'取消',
      },
      delete:'删除',

    },
    carbrand:{
      hint1:'请选择',
      select:{
        brandcn:'品牌(中文)查询',
        branden:'品牌(英文)查询',
      },
      hint2:'请输入内容',
      insert:{
        title:'新增汽车品牌',
        btn:'新增',
        brandid:'品牌ID',
        brandcn:'车辆品牌(中文)',
        branden:'车辆品牌(英文)',
      },
      operate:'操作',
      modify:{
        btn:'修改',
        title:'修改车辆品牌',
      },
      cancel:'取消',
      delete:'删除',
    },
  },
  sensorsmanage:{
    sensorsmanagename:'传感器数据管理',
    title:'传感器信息',
    sensorbaseinfo:{
      select:{
        hint:'请选择',
        mac:'传感器MAC',
        sensor:'传感器Sensor',
        phone:'手机号/邮箱',
      },
      hint:'请输入内容',
      insert:{
        btn:'新增传感器基本信息',
        mac:'传感器MAC',
        sensorid:'传感器Sensor ID',
        phone:'手机号/邮箱',
        bleconnectionSensor:'',
        companyID:'公司ID',
        ignstatus:'IGN状态',
        mileageOFTirePressureSensor:'胎压传感器里程',
        presentDateAndTime:'日期',
        projectCode:'工程代号',
        softwareVersion:'软件版本号',
        vehicleOdometer:'车辆里程表',
        // addData:'AD数据',
        insert:'新增',
        cancel:'取消',
      },
      mac:'传感器MAC',
      sensorid:'传感器Sensor ID',
      phone:'手机号/邮箱',
      modify:{
        btn:'修改',
        title:'修改传感器基本信息',
        mac:'传感器MAC',
        sensroid:'传感器Sensor ID',
        phone:'手机号',
        bleconnectionSensor:'',
        companyID:'公司ID',
        ignstatus:'IGN状态',
        mileageOFTirePressureSensor:'胎压传感器里程',
        presentDateAndTime:'日期',
        projectCode:'工程代号',
        softwareVersion:'软件版本号',
        vehicleOdometer:'车辆里程表',
        // addData:'AD数据',
        cancel:'取消',
      },
      delete:'删除',
    },
    sensordata:{
      historydata:{
        title:'历史数据',
        historydatatitle1:'传感器MAC为<',
        historydatatitle2:'>的历史数据',
        select:{
          hint1:'请选择',
          hint2:'请输入内容',
          1:'胎压',
          2:'温度',
          3:'标压',
          4:'标温',
        },
        insert:{
          btn:'新增传感器数据',
          title:'新增传感器数据',
          mac:'传感器MAC',
          sensorid:'传感器Sensor ID',
          tirep:'胎压/kPa',
          temperature:'温度/℃',
          stirep:'标压/kPa',
          stemperature:'标温/℃',
          insert:'新增',
          cancel:'取消',
        },
        inner_btn: '折线图',
        download_btn: '下载数据',
        downloading: "下载中",
        packaging: "打包中",
        inner:{
          basiclineP:{
            series:'胎压/kPa',
          },
          basiclineSP:{
            series:'标压/kPa',
          },
          basiclineT:{
            series:'温度/℃',
          },
          basiclineST:{
            series:'标温/℃',
          },
        },
        mac:'传感器MAC',
        sensorid:'传感器Sensor ID',
        phone:'手机号',
        bleconnectionSensor:'',
        companyID:'公司ID',
        ignstatus:'IGN状态',
        mileageOFTirePressureSensor:'胎压传感器里程',
        presentDateAndTime:'日期',
        projectCode:'工程代号',
        softwareVersion:'软件版本号',
        vehicleOdometer:'车辆里程表',
        // addData:'AD数据',
        operate:'操作',
        tirep:'胎压/kPa',
        temperature:'温度/℃',
        stirep:'标压/kPa',
        stemperature:'标温/℃',
        date:'时间',
        modify:{
          btn:'修改',
          title:'修改传感器数据',
          mac:'传感器MAC',
          sensorid:'传感器Sensor ID',
          tirep:'胎压',
          temperature:'温度',
          stirep:'标压',
          stemperature:'标温',
          modify:'修改',
          cancel:'取消',
        },
        delete:'删除',
      },
    },
  },
  applogmanage:{
    applogmanagename:'APP日志管理',
    searchhint:'输入用户手机号搜索',
    searchbtn:'搜索',
    insertlog:'新增日志',
    insert:{
      title:'新增日志',
      phone:'用户手机号',
      logdetail:'日志详情',
      cancel:'取消',
      insert:'新增',
    },
    logid:'日志ID',
    phone:'用户手机号',
    logdetail:'日志详情',
    logtype:'日志类型',
    createtime:'日志创建时间',
    operate:'操作',
    modify:{
      btn:'修改',
      title:'修改日志',
      logid:'日志ID',
      createtime:'日志创建时间',
      logtype:'日志类型',
      phone:'用户手机号',
      logdetail:'日志详情',
      cancel:'取消',
      modify:'修改',
    },
    delete:'删除',
  },
  syslogmanage:{
    syslogmanage:'系统日志管理',
    searchhint:'输入日志部分内容,按回车键搜索',
    searchbtn:'搜索',
    insertlog:'新增日志',
    insert:{
      title:'新增日志',
      logdetail:'日志详情',
      cancel:'取消',
      insert:'新增',
    },
    logid:'日志ID',
    logdetail:'日志详情',
    logtype:'日志类型',
    createtime:'日志创建时间',
    operate:'操作',
    modify:{
      btn:'修改',
      title:'修改日志',
      logid:'日志ID',
      createtime:'日志创建时间',
      logtype:'日志类型',
      logdetail:'日志详情',
      cancel:'取消',
      modify:'修改',
    },
    delete:'删除',
  },
  adminlogmanage:{
    adminlogmanage:'管理员日志管理',
    searchhint:'输入管理员账号搜索',
    searchbtn:'搜索',
    insertbtn:'新增日志',
    inserttitle:'新增日志',
    insertlogdetail:'日志详情',
    insertcancel:'取消',
    insertinsert:'新增',
    logid:'日志ID',
    adminname:'管理员',
    logtype:'日志类型',
    logdetail:'日志详情',
    createtime:'日志创建时间',
    operate:'操作',
    operatemodify:'修改',
    operatedelete:'删除',
    modifytitle:'修改日志',
    modifylogid:'日志ID',
    modifycreatetime:'日志创建时间',
    modifylogtype:'日志类型',
    modifylogdetail:'日志详情',
    modifycancel:'取消',
    modifymodify:'修改',
  },
  userinfo:{
    title:'基本信息',
    tab1:'基本信息',
    tab2:'修改密码',
    userinfo:{
      username:'用户名',
      ownrole:'拥有的角色',
    },
    useravatar:{
      title:'个人头像',
      loadingtext:'上传中...',
      beforeupload:'点击上传头像',
      tip:'只能上传jpg/png文件，且不超过500kb',
      
    },
    resetpwd:{
      oldpwd:'旧密码',
      oldpwdhint:'请输入旧密码',
      newpwd:'新密码',
      newpwdhint:'请输入新密码',
      confirmpwd:'确认密码',
      confirmpwdhint:'请确认密码',
      submit:'保存',
      close:'关闭',
      error1:'两次输入的密码不一致',
    },
  }
}